import { useEffect, useState } from "react";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hover, setHover] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(max-width: 768px)").matches) return;
    const move = (e: MouseEvent) => {
      setPos({ x: e.clientX, y: e.clientY });
      setVisible(true);
      const target = e.target as HTMLElement;
      const interactive = !!target.closest("a, button, [role='button'], input, textarea, select, [data-cursor='hover']");
      setHover(interactive);
    };
    const leave = () => setVisible(false);
    window.addEventListener("mousemove", move);
    document.body.addEventListener("mouseleave", leave);
    return () => {
      window.removeEventListener("mousemove", move);
      document.body.removeEventListener("mouseleave", leave);
    };
  }, []);

  if (!visible) return null;
  return (
    <>
      <div className="edx-cursor" style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)` }} />
      <div className={`edx-cursor-ring ${hover ? "hovering" : ""}`} style={{ transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)` }} />
    </>
  );
}
